<template>
  <div class="mainBox" id="courseTable">  

     <Table size="large" :columns="courseColumns" :data="courseData" stripe></Table>
  
		
  </div>
</template>
<script>
export default {
  data() {
    return {
      courseColumns: [
        // {
        //   title: "工号",
        //   key: "sid"
        // },
        // {
        //   title: "身份证号",
        //   key: "idCard",
        //   width:280
        // },
        // {
        //   title: "姓名",
        //   key: "name"
        // },
        // {
        //   title: "年度",
        //   key: "year"
        // },
		{
          title: "课程名称",
          key: "course",
		  width:200
        },
        {
          title: "任课教师",
		  width:100,
          key: "teacher"
        },
        {
          title: "校区",
          key: "campus",
          width:100
        },
        {
          title: "上课地址",
          key: "address",
          width:280
        },
        {
          title: "上课时间",
          key: "classBegin"
        },
        {
          title: "学期",
          key: "xq",
          render: (h, params) => {
            const text =
              params.row.xq === "1" ? "春季" : params.row.xq === "2"?"秋季":"";
            return h("div", +params.row.year+text);
          }
        }, 
    
        {
          title: "退费金额",
          key: "amount"
        },
        {
          title: "状态",
          key: "status",
          render: (h, params) => {
            const row = params.row; 
            const color = row.status === "0" ? "#ffae00" : row.status === "1" ? "#ffae00" : "#31c27c";
            const text = row.status === "0"  ? "待退课" : row.status === "1" ? "待退费" : "已退费";
            return h(
              "span",
              {
                style: {
                 
                  color: color
                }
              },
              text
            );
          }
        },
      ],
      courseData: [],
      userIdCard:""
    };
  },
  methods: {
    getDropCourseData() {
      var _this = this;
      _this.$http
        .get("retire-school-manage/refund/getSchoolRefunds", {
          params: {
            idCard:_this.userIdCard,
            startIndex: 1,
            endIndex: 10
          }
        })
        .then(res => {
          if (res.data.status == 2000) {
            _this.courseData = res.data.data.schoolRefundList;
          } else {
            // _this.$CustomMessageError(res.data.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getUserInfo () {
      var _this = this
      _this.$http.get("retire-school-manage/personal/getMyInfo", {
        params: {
          // studentId: 555 // 学员id
          studentId: _this.$store.state.studentId
        }
      }).then(res => {
        if (res.data.status == 2000) {
          _this.userIdCard = res.data.data.idCard
          _this.getDropCourseData();
        } else {
          console.log("数据获取失败")
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
  created() {
    this.getUserInfo()
    
  }
};
</script>
<style>
.mainBox{width: 1400px; margin:auto auto 50px auto;}
#courseTable div.ivu-card-body{ padding: 0}
#courseTable div.ivu-table-wrapper{border:none}
#courseTable .ivu-table:before{content:'';width:100%;height:0px;position:absolute;left:0;bottom:0;z-index:1}
#courseTable .ivu-table:after{content:'';width:0px;height:100%;position:absolute;top:0;right:0;z-index:3}
#courseTable .ivu-table th, .ivu-table td{ border:0; }
#courseTable .ivu-table-cell{ padding: 10px 18px !important;}
.myLeasson{ margin-bottom:50px;}
.myLeasson  h1{ font-size: 28px; padding:10px 0;}
</style>